import { render, staticRenderFns } from "./ComplianceFailingElements.vue?vue&type=template&id=685ed868&"
import script from "./ComplianceFailingElements.vue?vue&type=script&lang=ts&"
export * from "./ComplianceFailingElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports